import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';

import { FetchData } from './utils/DataFetch';
import { GetCookie } from './utils/Common';

import Logo from '../images/logo1.png';

export class WorkOrderIntConfNo extends Component {
  static displayName = WorkOrderIntConfNo.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));

    this.state = {
      display_message: '',
    };

    this.confirmEmail = this.confirmEmail.bind(this);
  }

  componentDidMount() {
    this.confirmEmail();
  }

  async confirmEmail() {
    let model = {
      UserID: this.user.userid,
      FirstName: this.user.firstname,
      LastName: this.user.lastname,
      Email: this.user.email,
      JobId: this.props.JobId,
      IntId: this.props.IntId,
    };

    if (this.props.notify_type === 'auth') {
      await FetchData(
        '/FinalConfirmationEmailToInterpreter',
        'POST',
        this.user.token,
        model
      ).then((data) => {
        this.props.handleSaveEventSuccess({
          message: data,
          modal: false,
          color: 'success',
        });
        //this.setState({
        //    display_message: data
        //});
      });
    } else {
      await FetchData(
        '/interpretersendcheckinemail',
        'POST',
        this.user.token,
        model
      ).then((data) => {
        this.props.handleSaveEventSuccess({
          message: data,
          modal: false,
          color: 'success',
        });
      });
    }
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ width: 'min(800px, 95vw)' }}
        >
          <ModalHeader>
            Final Appointment Confirmation (Interpreter)
          </ModalHeader>
          <ModalBody>
            <div>
              <Row>
                <Col>
                  <center>
                    <img src={Logo} alt="Logo" />
                  </center>
                </Col>
              </Row>
              <Row>
                <Col>
                  <center>
                    <p>{this.state.display_message}</p>
                  </center>
                </Col>
              </Row>
            </div>
          </ModalBody>
          {/*<ModalFooter>*/}

          {/*</ModalFooter>*/}
        </Modal>
      </div>
    );
  }
}
